angular
    .module('vppApp')
    .service('ThirdPartyMessages', ThirdPartyMessages);

ThirdPartyMessages.$inject = ['$rootScope', '$http', 'vppConfig'];

function ThirdPartyMessages($rootScope, $http, vppConfig) {
    var thirdPartyMessages = {};
    var messageList;

    thirdPartyMessages.setMessage = function (messsageName, type) {
        if (typeof (messageList) == 'undefined') {
            $http.get(vppConfig.errorMessagePath).then(function successCallback(response) {
                messageList = response.data.errors.messageName;
                $rootScope.externalMessage = { 'text': messageList[messsageName], 'messageType': type };
            });
        }
        else {
            $rootScope.externalMessage = { 'text': messageList[messsageName], 'messageType': type };
        };
    };

    return thirdPartyMessages;
};
